import { PayloadAction, createReducer } from '@reduxjs/toolkit';
import { focusTag } from '../store/uiSlice';
import { db, dbLog } from './db';
import { now } from 'lodash';
import { RootState } from '../store/rootState';






export const dbReducer = createReducer({} as RootState, (builder) => {
  builder


    .addCase(focusTag, (state, action: PayloadAction<{ tag: string }>) => {
      // Allow focusTag in UI context as it's not tracked by background listeners
      const { tag } = action.payload;

      if (tag != '#UNTAGGED') {
        dbLog('focusTag', tag);
        db.tags.put({ name: tag, last_active: now() });
      }
    })
});
